<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-5 mx-auto pt-3">

        <div v-if="changeMode">
          <h1 class="text-center pb-3">{{$t("Change Password")}}</h1>
          <change-password-form @changeSuccess="toggleMode" :csrfToken="csrfToken"></change-password-form>
        </div>

        <div v-else class="text-center">
          <h2>{{$t("Password was changed successfully")}}</h2>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
import ChangePasswordForm from '../../components/forms/ChangePasswordForm'

export default {
  components: {
    changePasswordForm: ChangePasswordForm,
  },
  data() {
    return {
      changeMode: true,
    }
  },
  methods: {
    toggleMode() {
      this.changeMode = !this.changeMode
    },
  },
  computed: {
    csrfToken: function() {
      return this.$store.getters.getToken
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-client-app/pages/auth/ChangePassPage.vue